import { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './queryClient';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * React Query Provider Component
 *
 * Wraps the app with QueryClientProvider and optional DevTools
 */
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools - Only in development */}
      {/* Disabled - uncomment to re-enable */}
      {/* {import.meta.env.DEV && (
        <ReactQueryDevtools
          initialIsOpen={false}
        />
      )} */}
    </QueryClientProvider>
  );
};
